import Vue from 'vue'
import Vuex, { Commit, Store } from 'vuex'

import addCreditCardModal from './modules/addCreditCardModal'
import auth from './modules/auth'
import bookingExtras from './modules/bookingExtras'
import bookings, { BookingsMutationTypes } from './modules/bookings'
import changePasswordModal from './modules/changePasswordModal'
import creditCards, { CreditCardMutationTypes } from './modules/credit-cards'
import creditNotes from './modules/creditNotes'
import customer from './modules/customer'
import customerNotifications, {
  CustomerNotificationsMutationTypes,
} from './modules/customerNotifications'
import facebook from './modules/facebook'
import forgotPasswordPage from './modules/forgotPasswordPage'
import invitePage from './modules/invitePage'
import loginPage from './modules/loginPage'
import messages from './modules/messages'
import newPasswordPage from './modules/newPasswordPage'
import passengerExtras from './modules/passengerExtras'
import passengers from './modules/passengers'
import paymentModal, { PaymentModalMutationTypes } from './modules/paymentModal'
import payments from './modules/payments'
import profileData from './modules/profileData'
import registrationPage from './modules/registrationPage'
import resetPasswordPage from './modules/resetPasswordPage'
import reviews from './modules/reviews'
import stripe from './modules/stripe'
import user from './modules/user'
import utility from './modules/utility'
import visaLetterModal, {
  VisaLetterModalMutationTypes,
} from './modules/visaLetterModal'

Vue.use(Vuex)

export enum GlobalMutationTypes {
  Reset = '[GlobalMutationTypes] Reset',
  ResetBookingRelatedModules = '[GlobalMutationTypes] ResetBookingRelatedModules',
}

export default new Store({
  modules: {
    auth,
    profileData,
    facebook,
    customer,
    user,
    loginPage,
    forgotPasswordPage,
    resetPasswordPage,
    registrationPage,
    invitePage,
    bookings,
    creditCards,
    stripe,
    addCreditCardModal,
    changePasswordModal,
    paymentModal,
    passengers,
    payments,
    creditNotes,
    reviews,
    visaLetterModal,
    messages,
    passengerExtras,
    newPasswordPage,
    utility,
    customerNotifications,
    bookingExtras,
  },

  actions: {
    [GlobalMutationTypes.Reset]({ commit }: { commit: Commit }) {
      commit(VisaLetterModalMutationTypes.Reset)
      commit(PaymentModalMutationTypes.Reset)
      commit(BookingsMutationTypes.Reset)
      commit(CreditCardMutationTypes.Reset)
      commit(CustomerNotificationsMutationTypes.Reset)
    },
    [GlobalMutationTypes.ResetBookingRelatedModules]({
      commit,
    }: {
      commit: Commit
    }) {
      commit(VisaLetterModalMutationTypes.Reset)
      commit(PaymentModalMutationTypes.Reset)
      commit(BookingsMutationTypes.ResetStatusBar)
    },
  },
})
